import { Amount, Loader } from "@/components";
import classNames from "classnames";
import { FunctionComponent, ReactElement } from "react";
import { Oval } from "react-loader-spinner";
import styles from "./Summaries.module.scss";
import { ISummariesProps } from "./types";

export const Summaries: FunctionComponent<ISummariesProps> = (
  props: ISummariesProps
): ReactElement<ISummariesProps> => {
  const {
    balance,
    className,
    currency,
    debts,
    income,
    loading = false,
    outcome,
    onPress,
    ...restProps
  } = props;

  return (
    <div className={classNames("row", className)} {...restProps}>
      <div className="col-lg-3 col-md-6 col-sm-6 col-6">
        <div
          className={classNames(
            "analyticsItem card lightBlockBg analyticsLink",
            styles.Summary
          )}
          onClick={onPress}
        >
          {loading ? (
            <Loader>
              <Oval
                height={21}
                width={21}
                color="#ffffff"
                wrapperStyle={{}}
                wrapperClass=""
                visible
                ariaLabel="oval-loading"
                secondaryColor="#ffffff"
                strokeWidth={1}
                strokeWidthSecondary={1}
              />
            </Loader>
          ) : (
            <Amount
              className="analyticsValue"
              currency={currency}
              value={income}
            />
          )}
          <span className="analyticsLabel">Доход</span>
        </div>
      </div>
      <div className="col-lg-3 col-md-6 col-sm-6 col-6">
        <div
          className={classNames(
            "analyticsItem card lightBlockBg analyticsLink",
            styles.Summary
          )}
          onClick={onPress}
        >
          {loading ? (
            <Loader>
              <Oval
                height={21}
                width={21}
                color="#ffffff"
                wrapperStyle={{}}
                wrapperClass=""
                visible
                ariaLabel="oval-loading"
                secondaryColor="#ffffff"
                strokeWidth={1}
                strokeWidthSecondary={1}
              />
            </Loader>
          ) : (
            <Amount
              className="analyticsValue"
              currency={currency}
              value={outcome}
            />
          )}
          <span className="analyticsLabel">Расход</span>
        </div>
      </div>
      <div className="col-lg-3 col-md-6 col-sm-6 col-6">
        <div
          className={classNames(
            "analyticsItem card lightBlockBg",
            styles.Summary
          )}
          onClick={onPress}
        >
          {loading ? (
            <Loader>
              <Oval
                height={21}
                width={21}
                color="#ffffff"
                wrapperStyle={{}}
                wrapperClass=""
                visible
                ariaLabel="oval-loading"
                secondaryColor="#ffffff"
                strokeWidth={1}
                strokeWidthSecondary={1}
              />
            </Loader>
          ) : (
            <Amount
              className="analyticsValue"
              currency={currency}
              value={balance}
            />
          )}
          <span className="analyticsLabel">Баланс</span>
        </div>
      </div>
      <div className="col-lg-3 col-md-6 col-sm-6 col-6">
        <div
          className={classNames(
            "analyticsItem card lightBlockBg",
            styles.Summary
          )}
          onClick={onPress}
        >
          {loading ? (
            <Loader>
              <Oval
                height={21}
                width={21}
                color="#ffffff"
                wrapperStyle={{}}
                wrapperClass=""
                visible
                ariaLabel="oval-loading"
                secondaryColor="#ffffff"
                strokeWidth={1}
                strokeWidthSecondary={1}
              />
            </Loader>
          ) : (
            <Amount
              className="analyticsValue"
              currency={currency}
              value={debts}
            />
          )}
          <span className="analyticsLabel">Долги</span>
        </div>
      </div>
    </div>
  );
};
